import urls from './urls';
import Images from '../themes/subsets/lookingToMeetApiImages';
import { DEFAULT_AGE_RANGE } from '../constants/category';
import axios from 'axios';
import { getLangQueryParams } from 'redhotpie-shared-lib/functions/utils';

const delay = 1000;
const lookingDataResponse = {
  success: true,
  statusCode: 200,
  message: 'Execute success',
  data: {
    items: [
      {
        ItemID: 'men',
        ItemName: 'Men',
        icSrc: Images.icWhoMen,
        active: false,
      },
      {
        ItemID: 'women',
        ItemName: 'Women',
        icSrc: Images.icWhoWoman,
        active: false,
      },
      {
        ItemID: 'couples',
        ItemName: 'Couples',
        icSrc: Images.icWhoCouple,
        active: false,
      },
      {
        ItemID: 'couplesFF',
        ItemName: 'Couples FF',
        icSrc: Images.icWhoCoupleFF,
        active: false,
      },
      {
        ItemID: 'couplesMM',
        ItemName: 'Couples MM',
        icSrc: Images.icWhoCoupleMM,
        active: false,
      },
      {
        ItemID: 'groups',
        ItemName: 'Groups',
        icSrc: Images.icWhoGroup,
        active: false,
      },
      {
        ItemID: 'tv_cd',
        ItemName: 'TV/CD',
        icSrc: Images.icWhoTVCD,
        active: false,
      },

      {
        ItemID: 'transWoman',
        ItemName: 'Trans Woman',
        icSrc: Images.icWhoTransWoman,
        active: false,
      },
      {
        ItemID: 'transMan',
        ItemName: 'Trans Man',
        icSrc: Images.icWhoTransMan,
        active: false,
      },
    ],
  },
};
const intentionsDataResponse = {
  success: true,
  statusCode: 200,
  message: 'Execute success',
  data: {
    items: [
      {
        id: 'dating',
        label: 'Dating',
        active: false,
      },
      {
        id: 'hookups',
        label: 'Hookups',
        active: false,
      },
      {
        id: 'sugarDating',
        label: 'Sugar Dating',
        active: false,
      },
      {
        id: 'discreetAffair',
        label: 'Discreet Affair',
        active: false,
      },
      {
        id: 'relationship',
        label: 'Relationship',
        active: false,
      },
      {
        id: 'friendship',
        label: 'Friendship',
        active: false,
      },
      {
        id: 'fwb',
        label: 'FWB',
        active: false,
      },
      {
        id: 'playFriends',
        label: 'Play Friends',
        active: false,
      },
      {
        id: 'social',
        label: 'Social',
        active: false,
      },
    ],
  },
};
const ageRangeDataResponse = {
  success: true,
  statusCode: 200,
  message: 'Execute success',
  data: {
    items: [
      {
        value: DEFAULT_AGE_RANGE.MIN,
      },
      {
        value: DEFAULT_AGE_RANGE.MAX,
      },
    ],
  },
};

class lookingToMeetApi {
  static loadLookingForData(params) {
    // this.restClient = new RestClient();
    // this.restClient.setBaseUrl(urls.BASE_RHPURL);
    const url = urls.GET_LOOKING_FOR_DATA;
    // return this.restClient.execute(url, ApiMethod.GET, null, true).then(res => {
    //   return res;
    // });
    return axios
      .get(url, { baseURL: urls.BASE_RHPURL, params: getLangQueryParams(params), headers: { isAnonymous: true } })
      .then(res => res);
  }

  static loadAgeRangeData() {
    return new Promise((resolve, reject) => {
      setTimeout(() => {
        resolve(Object.assign([], ageRangeDataResponse));
      }, delay);
    });
  }

  static loadIntentionsData() {
    // this.restClient = new RestClient();
    // this.restClient.setBaseUrl(urls.BASE_RHPURL);
    const url = urls.GET_INTENTIONS_DATA;
    // return this.restClient.execute(url, ApiMethod.GET, null, true).then(res => {
    //   return res;
    // });
    return axios.get(url, { baseURL: urls.BASE_RHPURL, headers: { isAnonymous: true } }).then(res => res);
  }
}

export default lookingToMeetApi;
